import { srchV3ItemToDlCenterRes } from 'pages/dlcenter/content/hooks/dlcenter-srch-mapper';
import { IfDlCenterRes } from 'pages/dlcenter/dlcenter-model';
import { apiDlCenterResByIds, fetchSrchV3Res, SRCH_V3_URL } from './srch-v3-api';
import {
  fixSrchV3Item,
  IfSrchV3Item,
  IfSrchV3ItemAddt,
  IfSrchV3ItemRaw,
  IfSrchV3Req,
  IfSrchV3Res,
} from './srch-v3-model';

export type IfSrchV3Page<T> = { items: T[]; totalCount: number };

export const getSrchFilterKey = (req: IfSrchV3Req) => {
  const { page, ...rest } = req;
  return JSON.stringify(rest);
};

export const parseSrchV3Items = (data: IfSrchV3Res): { items: IfSrchV3Item[]; totalCount: number } => ({
  items: data.result?.[0]?.items?.map((e) => fixSrchV3Item(e as unknown as IfSrchV3ItemRaw)) ?? [],
  totalCount: data.result?.[0]?.indexTotalCount ?? 0,
});

export const mergeDlCenterResById = <T extends { id?: number }>(items: T[], dlCenterRes: IfDlCenterRes[]): T[] => {
  const resMap = new Map(dlCenterRes.map((r) => [r.id, r]));
  return items.map((item) => {
    const r = resMap.get(item.id);
    if (r) return { ...item, discontinue: r.discontinue, docGrpId: r.docGrpId, files: r.files };
    return item;
  });
};

export const createSwrSrchV3Fetcher =
  (fetchAddt: boolean) =>
  async ([url, params]: [string, Record<string, unknown>]): Promise<IfSrchV3Page<IfSrchV3Item | IfSrchV3ItemAddt>> => {
    const data = await fetchSrchV3Res(url, params);
    const { items: srchV3Items, totalCount } = parseSrchV3Items(data);

    if (srchV3Items.length === 0) return { items: [], totalCount: 0 };
    if (!fetchAddt) return { items: srchV3Items, totalCount };

    const dlCenterRes = await apiDlCenterResByIds(srchV3Items.map((item) => item.id));
    return { items: mergeDlCenterResById(srchV3Items, dlCenterRes), totalCount };
  };

export const swrDlCenterFetcher = async ([url, params]: [string, Record<string, unknown>]): Promise<
  IfSrchV3Page<IfDlCenterRes>
> => {
  const data = await fetchSrchV3Res(url, params);
  const { items, totalCount } = parseSrchV3Items(data);
  const dlCenterItems = items.map(srchV3ItemToDlCenterRes);

  if (dlCenterItems.length === 0) return { items: [], totalCount: 0 };

  const dlCenterRes = await apiDlCenterResByIds(dlCenterItems.map((item) => item.id));
  return { items: mergeDlCenterResById(dlCenterItems, dlCenterRes), totalCount };
};

export { SRCH_V3_URL };
